(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.custom-hero-carousel');

  sections.forEach(function (section) {
    new Swiper(section, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      centeredSlides: false,
      watchOverflow: true,

      loop: section.dataset.loop === 'true',

      autoplay: section.dataset.autoplay === 'true'
        ? {
            delay: parseInt(section.dataset.autoplaySpeed, 10),
            disableOnInteraction: false,
          }
        : false,

      navigation: section.dataset.navigation === 'true'
        ? {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
          }
        : false,

      pagination: section.dataset.pagination === 'true'
        ? {
            el: section.querySelector('.swiper-pagination'),
            clickable: true,
          }
        : false,

      speed: 800,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
